module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', [_c('el-aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded',
    attrs: {
      "width": "140px"
    }
  }, [_c('div', {
    staticClass: "pa_logo_box",
    on: {
      "click": _vm.backMian
    }
  }, [_c('div', {
    staticClass: "name",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.merchant_name))])]), _vm._v(" "), _c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.hidden) ? _c('el-menu-item', {
      key: item.path,
      class: _vm.navRouter.path == item.path ? 'is-active' : '',
      attrs: {
        "index": item.path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name) + "\n          ")]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item",
      attrs: {
        "index": index
      }
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "45px",
        "line-height": "45px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pa_nav_user_info_box footer"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [(_vm.merchant_user_avatar) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.merchant_user_avatar
    }
  }) : _c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/avatar_null.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "myName",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.merchant_user_name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.post))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.btnMyCenter.apply(null, arguments)
      }
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.updatePassword.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectShop.apply(null, arguments)
      }
    }
  }, [_vm._v("切换店铺")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出系统")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-header', {
    staticClass: "pa_header_box",
    staticStyle: {
      "height": "60px",
      "padding-top": "10px"
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pathLength > 3),
      expression: "pathLength > 3"
    }],
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(_vm.$route.path != item.path) ? _c('a', {
      staticStyle: {
        "font-weight": "bold"
      },
      on: {
        "click": function($event) {
          return _vm.routeLink(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))])])
  }), 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pathLength < 4),
      expression: "pathLength < 4"
    }],
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.navRouter.children), function(item, index) {
    return (!item.hidden) ? _c('el-form-item', {
      key: index
    }, [_c('router-link', {
      staticClass: "pa_link",
      class: _vm.colorHeightCheck(item) ? 'on' : '',
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.name) + _vm._s(item.title))])], 1) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-main', [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])], 1), _vm._v(" "), _c('personCenter', {
    attrs: {
      "status": _vm.addEmployeeStatus
    },
    on: {
      "add": _vm.addPersonCenter
    }
  }), _vm._v(" "), _c('updateMi', {
    attrs: {
      "status": _vm.updateMiStatus
    },
    on: {
      "add": _vm.addUpdateMi
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cc06768"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 3501
// module chunks = 103